import { Dialog, DialogBody, DialogFooter, Intent } from "@blueprintjs/core";
import React from "react";

import { useDeletePlaysMutation } from "../../../../redux/slices";
import { SportPlay } from "../../../../types";
import { Button } from "../../../Button/button";
import styles from "./plays-to-delete-dialog.module.scss";

export interface PlaysToDeleteDialogProps<TPlay extends SportPlay> {
  playsToDelete: TPlay[];
  onClose: () => void;
  isOpen: boolean;
}

export const PlaysToDeleteDialog = <TPlay extends SportPlay>({
  isOpen,
  playsToDelete,
  onClose,
}: PlaysToDeleteDialogProps<TPlay>) => {
  const [deletePlays] = useDeletePlaysMutation();

  const handleDeletePlays = () => {
    deletePlays({ ids: playsToDelete.map((play) => play.id || "") });
    onClose();
  };

  return (
    <Dialog isOpen={isOpen} title="Delete Plays" canOutsideClickClose isCloseButtonShown onClose={onClose}>
      <DialogBody>
        <div> Are you sure you want to delete plays: </div>
        <ul className={styles.list}>
          {playsToDelete.map((play) => (
            <li key={play.id}>{play.name}</li>
          ))}
        </ul>
      </DialogBody>
      <DialogFooter>
        <div className={"bp4-dialog-footer-actions"}>
          <Button minimal intent={Intent.NONE} onClick={onClose}>
            Cancel
          </Button>
          <Button intent={Intent.DANGER} onClick={handleDeletePlays}>
            Delete
          </Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
};
